import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../store';
import axios from 'axios';
import { MessageModal, LoadingModal } from './component/modal/modal';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { Unlock } from 'lucide-react';

function LockedAccounts() {
    let dispatch = useDispatch();
    let navigate = useNavigate();
    let MyData = useSelector((state) => state.MyData);

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [merchants, setMerchants] = useState([]);
    const [agents, setAgents] = useState([]);
    const [totalMerchants, setTotalMerchants] = useState(0);
    const [totalAgents, setTotalAgents] = useState(0);
    const [unlocking, setUnlocking] = useState(null); // 해제 진행 중인 ID

    useEffect(() => {
        dispatch(changeHeaderTitle("잠긴 계정 관리"));
        dispatch(change_Current_Location("잠긴 계정 관리"));
        fetchLockedAccounts();
    }, []);

    const fetchLockedAccounts = async () => {
        setLoading(true);
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/account-lock", {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMerchants(tmp?.data?.merchants ?? []);
                setAgents(tmp?.data?.agents ?? []);
                setTotalMerchants(tmp?.data?.total_merchants ?? 0);
                setTotalAgents(tmp?.data?.total_agents ?? 0);
            } else if (tmp?.code === 9999) {
                navigate("/");
            } else {
                setMessage(tmp?.msg ?? "조회 중 오류가 발생했습니다.");
            }
        } catch (error) {
            setMessage("조회 중 오류가 발생했습니다.");
        } finally {
            setLoading(false);
        }
    };

    const handleUnlockMerchantLogin = async (mid) => {
        if (!window.confirm(`가맹점 [${mid}] 로그인 잠금을 해제하시겠습니까?`)) return;
        setUnlocking(mid + "_login");
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/api/merchant/unlock", { mid }, {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage("로그인 잠금이 해제되었습니다.");
                fetchLockedAccounts();
            } else {
                setMessage(tmp?.msg ?? "잠금 해제 중 오류가 발생했습니다.");
            }
        } catch (error) {
            setMessage("잠금 해제 중 오류가 발생했습니다.");
        } finally {
            setUnlocking(null);
        }
    };

    const handleUnlockMerchantPayPassword = async (mid) => {
        if (!window.confirm(`가맹점 [${mid}] 결제비밀번호 잠금을 해제하시겠습니까?`)) return;
        setUnlocking(mid + "_pay");
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/api/merchant/unlock-pay-password", { mid }, {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage("결제비밀번호 잠금이 해제되었습니다.");
                fetchLockedAccounts();
            } else {
                setMessage(tmp?.msg ?? "잠금 해제 중 오류가 발생했습니다.");
            }
        } catch (error) {
            setMessage("잠금 해제 중 오류가 발생했습니다.");
        } finally {
            setUnlocking(null);
        }
    };

    const handleUnlockAgent = async (agent_id) => {
        if (!window.confirm(`영업자 [${agent_id}] 잠금을 해제하시겠습니까?`)) return;
        setUnlocking(agent_id);
        try {
            const response = await axios.post(process.env.REACT_APP_API + "/api/agent/unlock", { agent_id }, {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMessage("잠금이 해제되었습니다.");
                fetchLockedAccounts();
            } else {
                setMessage(tmp?.msg ?? "잠금 해제 중 오류가 발생했습니다.");
            }
        } catch (error) {
            setMessage("잠금 해제 중 오류가 발생했습니다.");
        } finally {
            setUnlocking(null);
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";
        return dayjs(dateStr).format("YYYY-MM-DD HH:mm");
    };

    const thStyle = {
        padding: "8px 12px",
        textAlign: "center",
        fontSize: "12px",
        fontWeight: "600",
        whiteSpace: "nowrap",
        borderBottom: "2px solid #dee2e6",
        backgroundColor: "#f8f9fa",
    };

    const tdStyle = {
        padding: "8px 12px",
        textAlign: "center",
        fontSize: "12px",
        borderBottom: "1px solid #dee2e6",
    };

    const sectionTitle = {
        fontSize: "14px",
        fontWeight: "600",
        marginBottom: "8px",
        display: "flex",
        alignItems: "center",
        gap: "6px",
    };

    const badgeStyle = {
        display: "inline-block",
        padding: "2px 8px",
        borderRadius: "10px",
        fontSize: "11px",
        fontWeight: "600",
        backgroundColor: "#f8d7da",
        color: "#721c24",
    };

    return (
        <div style={{ padding: "16px" }}>
            {message && <MessageModal message={message} onClose={() => setMessage("")} />}
            {loading && <LoadingModal />}

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
                <div style={{ fontSize: "13px", color: "#666" }}>
                    잠긴 가맹점 <b>{totalMerchants}</b>건 / 잠긴 영업자 <b>{totalAgents}</b>건
                </div>
                <button
                    type="button"
                    className="btn btn-outline-secondary btn_small"
                    onClick={fetchLockedAccounts}
                    style={{ height: "30px", fontSize: "12px" }}
                >
                    새로고침
                </button>
            </div>

            {/* 가맹점 테이블 */}
            <div style={{ marginBottom: "24px" }}>
                <div style={sectionTitle}>
                    가맹점 잠금 목록
                    <span style={{ ...badgeStyle, marginLeft: "4px" }}>{totalMerchants}</span>
                </div>
                <div style={{ overflowX: "auto", border: "1px solid #dee2e6", borderRadius: "6px" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th style={thStyle}>가맹점 ID</th>
                                <th style={thStyle}>가맹점명</th>
                                <th style={thStyle}>로그인 실패</th>
                                <th style={thStyle}>로그인 잠금</th>
                                <th style={thStyle}>결제비밀번호 실패</th>
                                <th style={thStyle}>결제비밀번호 잠금</th>
                                <th style={thStyle}>잠금 시각</th>
                                <th style={thStyle}>로그인 해제</th>
                                <th style={thStyle}>결제비밀번호 해제</th>
                            </tr>
                        </thead>
                        <tbody>
                            {merchants.length === 0 ? (
                                <tr>
                                    <td colSpan={9} style={{ ...tdStyle, padding: "24px", color: "#999" }}>
                                        잠긴 가맹점이 없습니다.
                                    </td>
                                </tr>
                            ) : (
                                merchants.map((m, idx) => (
                                    <tr key={m.mid} style={{ backgroundColor: idx % 2 === 0 ? "#fff" : "#fafafa" }}>
                                        <td style={tdStyle}>{m.mid}</td>
                                        <td style={{ ...tdStyle, textAlign: "left" }}>{m.co_nm}</td>
                                        <td style={tdStyle}>{m.login_fail_count}회</td>
                                        <td style={tdStyle}>
                                            <span style={{
                                                ...badgeStyle,
                                                backgroundColor: m.login_locked ? "#f8d7da" : "#d4edda",
                                                color: m.login_locked ? "#721c24" : "#155724",
                                            }}>
                                                {m.login_locked ? "잠금" : "정상"}
                                            </span>
                                        </td>
                                        <td style={tdStyle}>{m.pay_password_fail_count}회</td>
                                        <td style={tdStyle}>
                                            <span style={{
                                                ...badgeStyle,
                                                backgroundColor: m.pay_password_locked ? "#f8d7da" : "#d4edda",
                                                color: m.pay_password_locked ? "#721c24" : "#155724",
                                            }}>
                                                {m.pay_password_locked ? "잠금" : "정상"}
                                            </span>
                                        </td>
                                        <td style={tdStyle}>{formatDate(m.locked_at)}</td>
                                        <td style={tdStyle}>
                                            {m.login_locked ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn_small"
                                                    onClick={() => handleUnlockMerchantLogin(m.mid)}
                                                    disabled={unlocking === m.mid + "_login"}
                                                    style={{
                                                        height: "26px",
                                                        fontSize: "11px",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "3px",
                                                        padding: "0 8px",
                                                    }}
                                                >
                                                    <Unlock size={12} />
                                                    {unlocking === m.mid + "_login" ? "해제중..." : "해제"}
                                                </button>
                                            ) : (
                                                <span style={{ color: "#999", fontSize: "11px" }}>-</span>
                                            )}
                                        </td>
                                        <td style={tdStyle}>
                                            {m.pay_password_locked ? (
                                                <button
                                                    type="button"
                                                    className="btn btn-warning btn_small"
                                                    onClick={() => handleUnlockMerchantPayPassword(m.mid)}
                                                    disabled={unlocking === m.mid + "_pay"}
                                                    style={{
                                                        height: "26px",
                                                        fontSize: "11px",
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "3px",
                                                        padding: "0 8px",
                                                    }}
                                                >
                                                    <Unlock size={12} />
                                                    {unlocking === m.mid + "_pay" ? "해제중..." : "해제"}
                                                </button>
                                            ) : (
                                                <span style={{ color: "#999", fontSize: "11px" }}>-</span>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* 영업자 테이블 */}
            <div>
                <div style={sectionTitle}>
                    영업자 잠금 목록
                    <span style={{ ...badgeStyle, marginLeft: "4px" }}>{totalAgents}</span>
                </div>
                <div style={{ overflowX: "auto", border: "1px solid #dee2e6", borderRadius: "6px" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                            <tr>
                                <th style={thStyle}>영업자 ID</th>
                                <th style={thStyle}>영업자명</th>
                                <th style={thStyle}>로그인 실패</th>
                                <th style={thStyle}>잠금 시각</th>
                                <th style={thStyle}>해제</th>
                            </tr>
                        </thead>
                        <tbody>
                            {agents.length === 0 ? (
                                <tr>
                                    <td colSpan={5} style={{ ...tdStyle, padding: "24px", color: "#999" }}>
                                        잠긴 영업자가 없습니다.
                                    </td>
                                </tr>
                            ) : (
                                agents.map((a, idx) => (
                                    <tr key={a.agent_id} style={{ backgroundColor: idx % 2 === 0 ? "#fff" : "#fafafa" }}>
                                        <td style={tdStyle}>{a.agent_id}</td>
                                        <td style={{ ...tdStyle, textAlign: "left" }}>{a.agent_nm}</td>
                                        <td style={tdStyle}>{a.login_fail_count}회</td>
                                        <td style={tdStyle}>{formatDate(a.locked_at)}</td>
                                        <td style={tdStyle}>
                                            <button
                                                type="button"
                                                className="btn btn-primary btn_small"
                                                onClick={() => handleUnlockAgent(a.agent_id)}
                                                disabled={unlocking === a.agent_id}
                                                style={{
                                                    height: "26px",
                                                    fontSize: "11px",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    gap: "3px",
                                                    padding: "0 8px",
                                                }}
                                            >
                                                <Unlock size={12} />
                                                {unlocking === a.agent_id ? "해제중..." : "해제"}
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default LockedAccounts;
